import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';

// Hook para UI
export const useUI = () => {
  const dispatch = useDispatch();
  const ui = useSelector(state => state.ui);

  const toggleSideMenu = useCallback(() => {
    dispatch({ type: 'ui/toggleSideMenu' });
  }, [dispatch]);

  const openSideMenu = useCallback(() => dispatch({ type: 'ui/openSideMenu' }), [dispatch]);
  const closeSideMenu = useCallback(() => dispatch({ type: 'ui/closeSideMenu' }), [dispatch]);

  const setTheme = useCallback(
    theme => dispatch({ type: 'ui/setTheme', payload: theme }),
    [dispatch]
  );

  const setUserTypeTheme = useCallback(
    userType => dispatch({ type: 'ui/setUserTypeTheme', payload: userType }),
    [dispatch]
  );

  const addNotification = useCallback(
    notification => dispatch({ type: 'ui/addNotification', payload: notification }),
    [dispatch]
  );

  const addAlert = useCallback(
    alert => dispatch({ type: 'ui/addAlert', payload: alert }),
    [dispatch]
  );

  const setIsInHeroSection = useCallback(
    isInHero => dispatch({ type: 'ui/setIsInHeroSection', payload: isInHero }),
    [dispatch]
  );

  return {
    ...ui,
    toggleSideMenu,
    openSideMenu,
    closeSideMenu,
    setTheme,
    setUserTypeTheme,
    addNotification,
    addAlert,
    setIsInHeroSection,
  };
};
